import { INotificationPlugin } from "./INotificationPlugin";
import { Notification } from "../../../api";

import Default from "./plugins/Default";

import NewFile from "./plugins/NewFile";

const plugins: Record<string, INotificationPlugin<any>> = {
  "NewFile": NewFile
};

const getPlugin = (item: Notification) => plugins[item.type] ?? Default;

export default {
  getTitle: (item: Notification) => getPlugin(item).title,
  getIcon: (item: Notification) => getPlugin(item).icon,
  getDescription: (item: Notification) => getPlugin(item).getDescription(item.data),
};
